import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/passage/page/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/park/passage/detail/v2', Object.assign({}, options, {
    params
  }));

export const beforeDelete = (params, options) =>
  request.post('/api/park/passage/beforeDelete/v2', qs.stringify(params), options);

export const remove = (params, options) =>
  request.post('/api/park/passage/remove/v2', qs.stringify(params), options);

export const openOrClose = (params, options) =>
  request.post('/api/park/passage/operate/v2', params, options);

export const grepImage = (params, options) =>
  request.post('/api/park/passage/grepImage/v2', params, options);

export const add = (params, options) => request.post('/api/park/passage/save/v2', params, options);

export const update = (params, options) =>
  request.post('/api/park/passage/update/v2', params, options);

export const passageSelections = (params, options) =>
  request.post('/api/park/passage/selections/v2', qs.stringify(params), options);

export const passageList = (params, options) =>
  request.post('/api/park/sentrybox/passage/passageList/v2', qs.stringify(params), options);

export const removePassage = (params, options) =>
  request.post('/api/park/passage/remove/v2', qs.stringify(params), options);
